import { CircularProgress } from '@mui/material';

import classes from './multipleRoundSpinner.module.scss';

const MultipleRoundSpinner = () => {
    return (
        <div className={classes.MultipleRoundSpinnerWrapper}>
            <CircularProgress color={'inherit'} />
        </div>
    );
};
export default MultipleRoundSpinner;
